import { render, staticRenderFns } from "./DynamicTagFallbackModal.vue?vue&type=template&id=7af78af9&scoped=true"
import script from "./DynamicTagFallbackModal.vue?vue&type=script&lang=js"
export * from "./DynamicTagFallbackModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicTagFallbackModal.vue?vue&type=style&index=0&id=7af78af9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af78af9",
  null
  
)

export default component.exports